import {
  ADMIN_FETCH_COMPANY_SUCCESS,
  ADMIN_FETCH_COMPANY_LIST_SUCCESS,
} from '../../actions/types';

const reducerCompanies = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_FETCH_COMPANY_SUCCESS:
      return {
        meta: { ...state.meta },
        companies: {
          ...state.companies,
          [action.payload.data.id]: action.payload.data,
        },
      };
    case ADMIN_FETCH_COMPANY_LIST_SUCCESS:
      return { companies: action.payload.data };
    default:
      return state;
  }
};

export default reducerCompanies;
